import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-event-reminder-scheduled-template',
  styleUrls: ['../../global-styles.less', './event-reminder-scheduled.component.less'],
  templateUrl: './event-reminder-scheduled.component.html',
  imports: [
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailMarginComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EventReminderScheduledTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<EventReminderScheduledTemplateData>;
}

export type EventReminderScheduledTemplateData = {
  p1: string;
  event_kind: string;
  event_link_label: string;
  when_label: string;
  date: string;
  event_link: string;
  timezone: string;
  interviewers_html: string;
  interviewers_label: string;
  reschedule_label: string;
  reschedule_link: string;
  reschedule_link_url: string;
};

export const EventReminderScheduledTemplateMocks: EventReminderScheduledTemplateData[] = [
  {
    p1: 'Upcoming event with CompanyName',
    event_kind: 'On-site interview',
    when_label: 'When',
    event_link_label: 'Event link',
    event_link: 'http://company_subdomain.recruitee.internal:3003/v/events/event_token',
    date: '29 January 2024 1:02 PM — 1:32 PM',
    timezone: '(GMT+01:00) Europe/Warsaw',
    interviewers_html: 'Maciej van der Sawi Langetermjin Nakomen',
    interviewers_label: 'Interviewers',
    reschedule_label: "Can't make it?",
    reschedule_link: 'Reschedule',
    reschedule_link_url: 'http://recruitee.com',
  },
];
